module.exports = __webpack_public_path__ + "static/media/man-laptop-v2.6ee29df5.svg";